/** @jsx jsx */
import React, {useState, useEffect} from 'react';
import { css, jsx } from '@emotion/core';
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import { productColor } from 'components/styles';
import Icon, {IconType} from 'components/atoms/Icon';
import BodyText from "components/atoms/BodyText";
import BoxMenuLeft from './BoxMenuLeft';
import { MenuItem, getHelpPage } from 'components/templates/menuData';
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';
import { Portal } from "react-portal";
import { checkBoxMenu } from 'components/templates/Sidebar';
import { useHistory, useLocation } from 'react-router-dom';

const style = {
  boxItem: css({
    padding: "10px 29px", 
    color: "#999999", 
    fontSize: "12px",
    "&:hover": {
      background: "#E7F1FD",
      color: productColor.primary,
      cursor: "pointer"
    }
  }),
  boxSubItem: css({
    cursor: "pointer",
    justifyContent: 'space-between',
    padding: '5px 0'
  }),
  subMenuLevel1: css({
    padding: "10px", 
    cursor: "pointer"
  }),
  activeItem: css({
    background: "#E7F1FD",
    color: productColor.primary,
    cursor: "pointer"
  }),
  boxMenu: css({
    borderBottom: "1px solid #e6e6e6",
    padding: "10px 0",
    position: 'relative',
    zIndex: 999,
    maxWidth: '210px'
  }),
  boxSubMenu: css({
    overflow: 'hidden',
    maxHeight: '1000px',
    transition: 'max-height 1.3s linear'
  })
};

const getStylePortal = (top: number, left: number) => {
  return css({
    zIndex: 9999, 
    top: top + 28,
    left: left + 30, 
    position: 'absolute',
    background: 'white',
    border: '1px solid #e6e6e6',
    width: '200px'
  })
};

const BoxGroupMenuLeft: React.FC<{
  display: string,
  icon: string,
  menuList?: any
}> = ({ display, icon, menuList }) => {
  const location = useLocation();

  let group = location.pathname.split('/')[1];
  
  const collapsedSidebar = useSelector((state:Store) => state.ui.appBar.collapsedSidebar);

  const [stateClick, setStateClick] = useState(
    menuList?.filter((item: any) => checkBoxMenu(item, group)).length > 0
  );

  const [openPortalMenu, setOpenPortalMenu] = useState(false);
  const [openPortalMenuPortal, setOpenPortalMenuPortal] = useState(false);
  const [posBottom, setPosBottom] = useState(0);
  const [posLeft, setPosLeft] = useState(0);
  
  const refCallback = (el: any) => {
    if(el) {
      let position = el.getBoundingClientRect();
      setPosBottom(position.top + window.pageYOffset);
      setPosLeft(position.left + window.pageXOffset);
    }
  };

  const handleClick = () => {
    let site: string | null = sessionStorage.getItem('loginUser.site');

    if(menuList?.length === 1 && menuList[0]?.value === 'help') {
      getHelpPage(Number(site));
    }

    if(!collapsedSidebar) {
      setStateClick(!stateClick);
    }
  };

  const handleMouseEnter = () => {
    if(collapsedSidebar) {
      setOpenPortalMenu(true);
    }
  };

  const handleMouseLeave = () => {
    if(collapsedSidebar) {
      // setTimeout(() => {
      //   setOpenPortalMenu(false);
      // }, 500); //delay 0.5s when leaving mouse
      setOpenPortalMenu(false);
    }
  };

  const handleMouseEnterPortal = () => {
    if(collapsedSidebar) {
      setOpenPortalMenuPortal(true);
    }
  };

  const handleMouseLeavePortal = () => {
    if(collapsedSidebar) {
      setOpenPortalMenuPortal(false);
    }
  };

  // useEffect(() => {
  //   let group = location.pathname.split('/')[1];
  //   let currentMenu: number|null = null;
  //   console.log('menuList', menuList, group);
  //   menuList.filter((item: any) => checkBoxMenu(item, group)).length > 0)
  // }, []);

  useEffect(() => {
    setOpenPortalMenu(false);

    if(collapsedSidebar) {
      setStateClick(false);
    }
  }, [collapsedSidebar]);

  let listSubMenu = menuList && 
                    (menuList?.length > 1 || menuList[0]?.value !== 'help') && 
                    menuList?.map((menuList: MenuItem, index: number) => {
                      
    return (
      <BoxMenuLeft
        display={menuList?.display}
        value={menuList?.value}
        subMenu={menuList?.subMenu}
        level={2}
      />
    );
  });  

  let listSubMenuPortal = menuList && menuList.map((menuList: MenuItem, index: number) => {
    return (
      <BoxMenuLeft
        display={menuList?.display}
        value={menuList?.value}
        subMenu={menuList?.subMenu}
        level={2}
        portal={true}
      />
    );
  });  

  return(
    <div style={{overflowX: 'visible'}}>
      <div css={style.boxMenu} ref={refCallback}>
        <FlexBox 
          customStyle={style.boxSubItem} 
          onClick={handleClick} 
          onMouseEnter={handleMouseEnter} 
          onMouseLeave={handleMouseLeave}
        >
          <FlexBoxItem>
            <Icon 
              type={icon as IconType} 
              color="black" 
              size="20px" 
              margin="0 15px 0 0"
            />
            <BodyText color="black">{display}</BodyText>
          </FlexBoxItem>
          <FlexBoxItem 
            customStyle={
              css([
                {transition: '0.5s', marginRight:'10px'},
                stateClick ? {transform: 'rotate(90deg)'} : {}
              ])
            }
          >
            {
              (menuList?.length > 1 || menuList[0]?.value !== 'help') && (
                <Icon 
                  type={"chevronMenu"}
                  color={productColor.primary} 
                  size="12px" 
                  verticalAlign="middle"
                />
              )
            }
          </FlexBoxItem>
        </FlexBox>
        {
          (openPortalMenu || openPortalMenuPortal) && (menuList?.length > 1 || menuList[0]?.value !== 'help') && (
            <Portal node={document.body}>
              <div 
                css={getStylePortal(posBottom, posLeft)} 
                onMouseEnter={handleMouseEnterPortal} 
                onMouseLeave={handleMouseLeavePortal}
              >
                {listSubMenuPortal}
              </div>
            </Portal>
          )
        }
        <div 
          css={
            css([
              style.boxSubMenu, 
              stateClick ? {} : {maxHeight: '0', transition: 'max-height 0.5s linear'}
            ])
          }
        >
          {listSubMenu}
        </div>
      </div>
    </div>
  );
};

export default BoxGroupMenuLeft;
